"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var FormStepsItem_1 = __importDefault(require("./FormStepsItem"));
var PostTabsContext_1 = require("../../../../contexts/PostTabsContext");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FormSteps = function () {
    var _a;
    var postTabs = react_1.useContext(PostTabsContext_1.PostTabsContext).postTabs;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.form_steps },
        react_1.default.createElement("ul", { className: styles_module_scss_1.default.form_steps_menu }, (_a = postTabs === null || postTabs === void 0 ? void 0 : postTabs.tabs) === null || _a === void 0 ? void 0 : _a.map(function (tab, idx) {
            return react_1.default.createElement(FormStepsItem_1.default, { idx: idx, tab: tab, key: idx });
        }))));
};
exports.default = FormSteps;
